import { apiOrigin } from "@/lib/env";

/** Resolve stored menu image paths to a browser-loadable URL. */
export function resolveMediaUrl(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url) || url.startsWith("data:")) return url;
  if (url.startsWith("/")) return `${apiOrigin()}${url}`;
  return `${apiOrigin()}/${url.replace(/^\//, "")}`;
}
